// extracted by mini-css-extract-plugin
module.exports = {"label_spec":"breadcrumb_label_spec__3ciAA","breadcrumb":"breadcrumb_breadcrumb__2IVwk","active":"breadcrumb_active__3szTf"};